import Button from "./common/Button";
import Image from "./common/Image";
import DOMPurify from 'dompurify'

function Teaser(props) {
  let classNames = `${
    props.className ?? ""
  } md:tw-bg-gray-light md:tw-rounded-xl`;

  if (props.color && props.color === "gray-light")
    classNames += " tw-bg-gray-light";

  let innerClassNames = `${
    props.layout && props.layout === "horizontal" ? "" : "lg:tw-flex"
  } ${
    props.index % 2 ? "md:odd:tw-flex-row-reverse" : ""
  } tw-px-2 tw-py-5 tw-max-w-screen-lg tw-m-auto`;

  let imageClassNames =
    props.layout && props.layout === "horizontal" ? "" : "lg:tw-w-2/4";
  let contentClassNames =
    props.layout && props.layout === "horizontal"
      ? ""
      : "lg:tw-w-2/4 lg:tw-p-12";

  return (
    <div className={classNames+" [&_li]:tw-ml-4"}>
      <div
        className={
          innerClassNames + " lg:tw-p-0 lg:tw-rounded-2xl lg:tw-bg-gray-light"
        }
      >
        <div
          className={`${imageClassNames} tw-m-3 tw-mt-0 lg:tw-m-0 lg:tw-p-5`}
        >
          <Image
            className="lg:tw-h-full lg:tw-object-cover tw-rounded-2xl lg:tw-h-auto"
            src={props.image}
          />
        </div>
        <div
          className={`${contentClassNames} tw-m-3 tw-mt-6 md:tw-p-5 md:tw-pt-8 lg:tw-m-0`}
        >
          <h2 className="tw-text-2xl lg:tw-text-3xl tw-font-condensed tw-font-black tw-italic tw-uppercase tw-pr-10">
            {props.title}
          </h2>
          {props.text && (
            <div className="tw-mt-2 [&_li]:tw-list-disc [&_li]:tw-ml-4">
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }} />  
            </div>
          )}
          {props.buttons && (
            <div className="tw-mt-6 tw-space-y-4">
              {props.buttons.map((buttonProps, index) => {
                return (
                  <Button
                    className="tw-w-full md:tw-w-auto lg:tw-px-8"
                    {...buttonProps}
                    key={"button_" + index}
                  />
                );
              })}
            </div>
          )}
          {props.pricing && (
            <>
              <div className="tw-mt-5">
                {props.pricing.values.map((item, index) => {
                  return (
                    <div key={"price_" + index} className="tw-inline-block">
                      {typeof item.prepend !== undefined && (<span className="tw-text-xs tw-uppercase tw-ml-0 tw-mr-2">{item.prepend}</span>)}
                      {index !== 0 && (
                        <span className="tw-text-teal tw-text-2xl tw-uppercase tw-italic tw-px-2">
                          /
                        </span>
                      )}
                      <span className="tw-text-teal tw-font-condensed tw-font-black tw-text-3xl tw-uppercase tw-italic">
                        {item.value}
                      </span>
                      <span className="tw-text-xs tw-uppercase tw-ml-1">
                        {item.label}
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className="tw-font-condensed tw-font-black tw-uppercase">
                {props.pricing.startup === 0 || props.pricing.startup === "" ? props.pricing.caption : "CHF "+props.pricing.startup+" "+props.pricing.caption}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Teaser;
